// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3NqfZ","label":"styles_label__2ai94","aligned":"styles_aligned__243wu","alignedRight":"styles_alignedRight__1q3sQ","text":"styles_text__1xEWd"};